module.exports = __webpack_public_path__ + "static/media/beach.55ae4c94.jpg";